import React, { useState, useEffect } from 'react';
import { Menu, X, TowerControl as GameController } from 'lucide-react';
import Button from './Button';
import Container from './Container';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  return (
    <header 
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? 'bg-background/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <Container>
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <GameController className="h-8 w-8 text-primary" />
              <span className="text-xl font-bold">WIZANTIX</span>
            </a>            
          </div>
          
          <nav className="hidden md:flex md:items-center md:space-x-8">
            <a href="#features" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Features
            </a>
            <a href="#for-hobbyists" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              For Hobbyists
            </a>
            <a href="#for-developers" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              For Developers
            </a>
            <a href="#showcase" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Showcase
            </a>
            <a href="https://wizantix.ai" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Wizantix.ai
            </a>
            <a href="#contact" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Contact
            </a>
            <Button size="sm" onClick={() => document.getElementById('CalltoAction')?.scrollIntoView({ behavior: 'smooth' })}>Join Waitlist</Button>
          </nav>
          
          <div className="flex md:hidden">
            <button 
              onClick={toggleMenu}
              className="inline-flex items-center justify-center rounded-md p-2 text-foreground hover:bg-accent hover:text-accent-foreground"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">{isMenuOpen ? 'Close menu' : 'Open menu'}</span>
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </Container>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="space-y-1 px-2 pb-3 pt-2">
            <a 
              href="#features" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </a>
            <a 
              href="#for-hobbyists" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              For Hobbyists
            </a>
            <a 
              href="#for-developers" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              For Developers
            </a>
            <a 
              href="#showcase" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              Showcase
            </a>
            <a 
              href="https://wizantix.ai" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              Wizantix.ai
            </a>
            <a 
              href="#contact" 
              className="block rounded-md px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
            <div className="mt-4 px-3">
              <Button fullWidth onClick={() => document.getElementById('CalltoAction')?.scrollIntoView({ behavior: 'smooth' })}>Join Waitlist</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;